import { forwardRef, MouseEvent } from 'react';
import { IconButton, useTheme } from '@material-ui/core';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

export interface WbTablePaginationActionsProps {
  backIconButtonProps?: object;
  count: number;
  nextIconButtonProps?: object;
  onChangePage?: (event: MouseEvent<HTMLButtonElement>, page: number) => void;
  onPageChange?: (event: MouseEvent<HTMLButtonElement>, page: number) => void;
  page: number;
  rowsPerPage: number;
  className?: string;
}

/**
 * Internal component for table pagination actions (previous/next buttons)
 */
export const WbTablePaginationActions = forwardRef<
  HTMLDivElement,
  WbTablePaginationActionsProps
>(function WbTablePaginationActions(props, ref) {
  const {
    backIconButtonProps,
    count,
    nextIconButtonProps,
    onChangePage = () => {},
    onPageChange = () => {},
    page,
    rowsPerPage,
    className,
    ...other
  } = props;

  const theme = useTheme();

  const handleBackButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onChangePage(event, page - 1);
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onChangePage(event, page + 1);
    onPageChange(event, page + 1);
  };

  return (
    <div ref={ref} className={className} {...other}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        color="inherit"
        {...backIconButtonProps}
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={
          count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false
        }
        color="inherit"
        {...nextIconButtonProps}
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </div>
  );
});
